// ── Место в аудио: где остановились, что слушали последним ─────────────────────

// Аудио, которое слушали последним (место сохраняет плеер, свежее — в конце списка).
export function lastPlayed(projects){
  let all={};try{all=JSON.parse(localStorage.getItem(PLAY_POS_KEY)||"{}");}catch{}
  const ids=Object.keys(all);
  for(let i=ids.length-1;i>=0;i--){const p=projects.find(x=>x.id===ids[i]);if(p)return{p,pos:all[ids[i]]||0};}
  return null;
}
export const fmtClock=(t)=>`${Math.floor(t/60)}:${String(Math.floor(t%60)).padStart(2,"0")}`;

// ── Место в аудио по проектам: продолжить с него при следующем открытии ─────
export const PLAY_POS_KEY="ac_play_pos";
export const readPlayPos=(id)=>{try{return JSON.parse(localStorage.getItem(PLAY_POS_KEY)||"{}")[id]||0;}catch{return 0;}};
export const savePlayPos=(id,t,dur)=>{
  try{
    const all=JSON.parse(localStorage.getItem(PLAY_POS_KEY)||"{}");
    delete all[id];
    if(!(dur&&t>dur-5))all[id]=Math.round(t); // дослушали до конца — в следующий раз сначала
    const ids=Object.keys(all);
    if(ids.length>300)delete all[ids[0]];      // храним последние 300 проектов
    localStorage.setItem(PLAY_POS_KEY,JSON.stringify(all));
  }catch{}
};
